<template>
  <div
    class="setting-popup"
    v-if="boxData.judgeBox"
    :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex, }"
    @mousedown="stopDocument($event);hideEyedropperBox()"
    @click.stop
  >
    <div
      class="setting-popup__drag-area"
      v-on:mousedown="moveStart($event, true)"
      v-on:mousemove="moveArea($event)"
      v-on:mouseup="saveMoveState($event)"
      :style="{'cursor': 'move'}"
    >选择颜色</div>
    <div class="setting-popup__content">
      <div class="setting-popup__recent-color" v-show="recentColors && recentColors.length">
        <div>最近使用</div>
        <ul>
          <li
            v-for="(color, i) in recentColors"
            :key="i"
            :style="{backgroundColor: color.hex}"
            @click="onClickRecentColor(color)"
          ></li>
        </ul>
      </div>
      <picker
        v-model="colors"
        :presetColors="presetColors"
        @input="updateColor"
        @eyedropper-start="onEyedropperStart"
        @colorNone="onColorNone"
        ref="pickerRef"
      ></picker>
    </div>
    <div class="setting-popup__close" @click="close">
      <i class="icon-popup-close"></i>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import popup from "../mixins/popup";
// import { Sketch } from 'vue-color'
import Sketch from "./content/colorPickerSketch";
import tinycolor from "tinycolor2";
import Analysis from "../mixins/analysis/materialBu";
import domToImage from "@/plugins/dom-to-image";
import snap from "@/components/mixins/snap";
import textArtStyle from "@/components//mixins/textArtStyle";
// const { html2canvas } = require('@/plugins/html2canvas')

const myPopup = {
  ...popup,
  watch: {}
};

export default {
  name: "color-picker",
  components: {
    picker: Sketch
  },
  mixins: [myPopup, Analysis, snap, textArtStyle],
  data() {
    return {
      spriteType: "color",
      popupType: "color",
      color: "#5778fb",
      from: null,
      recentColors: [],
      cacheJudge: null,
      presetColors: [
        "#FFFFFF",
        "#CDD9DD",
        "#AFBFC5",
        "#76919A",
        "#35484F",
        "#000000",
        "#1289E2",
        "#6BB9F0",
        "#00C952",
        "#FFEA01",
        "#FE6B0E",
        "#FF1943"
      ]
    };
  },
  computed: {
    colors: {
      get() {
        let color = tinycolor(this.color);
        return {
          // hex: '#194d33',
          // hsl: { h: 150, s: 0.5, l: 0.2, a: 1 },
          // hsv: { h: 150, s: 0.66, v: 0.30, a: 1 },
          // rgba: { r: 25, g: 77, b: 51, a: 1 },
          hex: color.toHexString(),
          hsl: color.toHsl(),
          hsv: color.toHsv(),
          rgba: color.toRgb(),
          a: 1
        };
      },
      set(val) {
        this.color = (val && val.hex) || "";
      }
    },
    colorPopupType() {
      if (this.SelectSprites_Msg.length) {
        return "color_" + this.SelectSprites_Msg[0].type;
      }
    },
    ...mapGetters([
      "TOOL",
      "Tool_Size",
      "TopNav_Size",
      "MaterialPane_Size",
      "BgOperation"
    ])
  },
  watch: {
    "boxDatas.firstDatas": function(val, oldval) {
      // 判断打开关闭
      const vm = this;
      let popupType = this.spriteType;
      let num = Array.indexOf(val, popupType);
      if (num < 0) {
        popupType = this.colorPopupType;
        num = val.indexOf(popupType);
      }
      if (this.boxDatas.firstDatas && this.boxDatas.firstDatas.length > 1) {
        this.from = this.boxDatas.firstDatas[
          this.boxDatas.firstDatas.length - 2
        ];
      }
      this.boxData.judgeBox = num < 0 ? false : true; // 判断是否打开

      if (this.TOOL && this.boxData.judgeBox) {
        // 打开的操作
        this.boxData.data = this.dataMsg[popupType];
        this.sprite = this.boxData.data.sprite;
        this.boxData.Zindex = (this.dataMsg.length + 1) * 5;
        this.source = this.boxData.data.source;
        // 有source字段弹窗中的拾色器弹窗
        if (this.source) {
          let rect = this.source.rect;
          if (rect) {
            this.boxData.fix.x = rect.left + 28;
            this.boxData.fix.y = rect.top + 28;
          } else {
            this.boxData.fix.x = this.source.boxData.fix.x + 28;
            this.boxData.fix.y = this.source.boxData.fix.y + 28;
          }

          if (this.boxData.data.posx) {
            this.boxData.fix.x = this.boxData.data.posx + 28;
          }
          if (this.boxData.data.posy) {
            this.boxData.fix.y = this.boxData.data.posy + 28;
          }
        }
        // 无source字段
        else {
          this.boxData.fix.x =
            this.boxData.data.posx != null
              ? this.boxData.data.posx
              : this.TOOL.PfixLeft +
                this.SelectSprites_Msg[0].positionLeft -
                280;
          this.boxData.fix.y =
            this.boxData.data.posy != null
              ? this.boxData.data.posy
              : this.TOOL.PfixTop + this.SelectSprites_Msg[0].positionTop;
        }

        this.color = this.boxData.data.color || this.color; // 设置拾色器打开时的颜色
      }

      if (this.TOOL && !this.boxData.judgeBox && this.cacheJudge) {
        let filtered = this.recentColors.filter(
          color => color.hex === vm.color
        );
        let hasColor = filtered && filtered.length;
        if (hasColor) {
          let myIndex = this.recentColors.indexOf(filtered[0]);
          let spliced = this.recentColors.splice(myIndex, 1);
          this.recentColors = [...spliced, ...this.recentColors];
        } else {
          this.recentColors.unshift({
            hex: this.color
          });
        }
        this.recentColors = this.recentColors.slice(0, 6);
      }
      this.cacheJudge = this.boxData.judgeBox;
    },

    "boxData.judgeBox": {
      handler(val) {
        if (!val) {
          this.$bus.emit("colorPickerClosed", this);
          return;
        }
        this.$nextTick(() => {
          if (this.boxData.data.hasEyedropper === false) {
            this.$refs.pickerRef.toggleEyedropper(false);
          } else {
            this.$refs.pickerRef.toggleEyedropper(true);
          }

          if (this.boxData.data.draw) {
            let arr = [...(this.presetColors || [])];
            this.presetColorsMemory = this.presetColors;
            arr[arr.length - 1] = "none";
            this.presetColors = arr;
          } else {
            this.presetColors = this.presetColorsMemory;
          }
        });
      }
    }
  },
  mounted() {
    this.$bus.on("eyedropper.sendData", (data, { isInputColor } = {}) => {
      let { r, g, b } = data;
      let colorTranslator = tinycolor({ r, g, b });
      this.color = colorTranslator.toHexString();

      if (!isInputColor) {
        return;
      }
      this.$refs.pickerRef &&
        this.$refs.pickerRef.colorChange({
          hex: this.color,
          source: "hex"
        });
      this.$bus.emit("eyedropperBox.hide");
    });

    this.$bus.on("eyedropperBox.prepareStart", () => {
      this.$refs.pickerRef && this.$refs.pickerRef.eyedropperWaitingStart();
    });

    this.$bus.on("eyedropperBox.ready", () => {
      this.$refs.pickerRef && this.$refs.pickerRef.eyedropperWaitingEnd();
    });
  },
  methods: {
    updateColor(obj) {
      if (!this.source) {
        this.updateColorByEngine({
          hex: obj.hex,
          whichPart: this.boxData.data.whichPart
        });
        this.$bus.emit("colorPickerInput.picker", obj, {
          type: this.boxData.data.whichPart
        });
        return;
      }
      let suffix = this.from ? `.${this.from}` : ""; // 后缀名表示此二级窗来自哪个一级窗
      this.$emit("input", obj);
      this.$bus.emit(`colorPickerInput${suffix}`, obj, {
        type: this.boxData.data.whichPart
      });
    },
    updateColorByEngine({ hex, whichPart }) {
      if (this.boxData.data.scenes) {
        let sceneBgProps = this.SelectScenes_Msg.background;
        let sceneBgData = sceneBgProps.data.data || {};
        let bgOpts = {
          // 设置场景背景
          resourceId: null, // 背景资源id
          fileType: null, // 背景资源type
          type: "Color", // 背景类型 0:Color 1:Image 2:Video
          data: {
            // 颜色背景的数据
            color: hex, // 颜色值,8位数
            blur: 0, // 高斯模糊
            opacity: 1 // 高斯模糊参数
          },
          zoomActive: false
        };
        if (this.BgOperation === "swap") {
          bgOpts.data = {
            ...bgOpts.data,
            blur: sceneBgData.blur,
            opacity: sceneBgData.opacity
          };
          bgOpts.zoomActive = sceneBgProps.zoomActive;
          bgOpts.zoomOptions = sceneBgProps.zoomOptions;
        }
        this.SelectScenes_Msg.setBackground(bgOpts, null, true);
        if (this.BgOperation === "swap") {
          this.$store.commit("save_BgOperation", "add");
        } else {
          // this.SelectScenes_Msg.setBgZoom(false);
        }
        this.materialPushAnalysis({ type: "bgColor" });
      } else if (this.boxData.data.draw) {
        this.$bus.emit(
          "colorPickerInput.draw",
          { hex: hex },
          { type: whichPart }
        );
      } else if (this.boxData.data.rich) {
        this.$bus.emit(
          "colorPickerInput.richTextEdit",
          { hex: hex },
          { type: whichPart }
        );
      } else {
        if(!this.sprite) return;
        let sprite = this.SelectSprites_Msg[0];
        let { type } = sprite;
        if (type === "Svg") {
          this.TOOL.updateSprite(
            this.sprite.id,
            {
              [whichPart]: hex
            },
            null,
            true
          );
          this.$bus.emit('btn_panel', {type: `${whichPart}Color`, data: hex})
        }
        if (type === "Shape") {
          this.TOOL.updateSprite(
            this.sprite.id,
            {
              style: {
                color: hex
              }
            },
            null,
            true
          );
        }
        if (type === "Text") {
          this.TOOL.updateSprite(
            this.sprite.id,
            {
              font: {
                color: hex
              },
              artStyle: this.getStyle(
                this.sprite.artType,
                hex,
                this.sprite.font.fontSize
              )
            },
            null,
            true
          );
          this.$bus.emit('btn_panel', {type: 'fontColor', data: hex})
        }
      }
    },
    getSpriteColor() {
      let color;
      if (this.boxData.data.scenes) {
        let scenesData = this.SelectScenes_Msg.background.data;
        if (scenesData.type === "Color") {
          color = scenesData.data.color;
        } else {
          color = "#fff";
        }
      } else if (this.boxData.data.draw) {
        color = this.boxData.data.drawData.color;
      } else {
        let sprite = this.SelectSprites_Msg[0] || {};
        if (sprite.type === "Svg") {
          color = sprite.fill;
        }
        if (sprite.type === "Shape") {
          color = sprite.option.style.color;
        }
        if (sprite.type === "Text") {
          color = sprite.font.color;
        }
      }
      return color || "#5778fb";
    },
    onClickRecentColor(colorObj) {
      let { hex } = colorObj;
      this.$refs.pickerRef.handlePreset(hex);
    },
    onEyedropperStart() {
      let box = document.body.querySelector("#app > .EyedropperBox");
      if (box && box.style.display !== "none") {
        return;
      }

      this.$bus.emit("eyedropperStart");
      this.$analysis({
        category: "material_setting_panel",
        action: "click_palette_color_picker",
        label: "素材设置_取色面板_取色器"
      });
    },
    async onEyedropperStartx() {
      this.$bus.emit("eyedropperBox.show");
      this.$refs.pickerRef.eyedropperWaitingEnd();

      await this.TOOL.setOption({
        width: this.Tool_Size.width,
        height: this.Tool_Size.height - 40,
        scale: 1,
        surplusY: this.TopNav_Size.height + 40,
        surplusX: this.MaterialPane_Size.width
      });

      if (
        this.TOOL.selectedScenes.element.content.find(".mask-blur>video")
          .length > 0
      ) {
        await this.beforeGetSnap({
          palyerScene: this.TOOL.selectedScenes.element.content[0],
          scene: this.TOOL.selectedScenes
        });
      }
      // let dom = document.querySelector('#app>.Tool .scroll-visible');
      let dom = this.TOOL.getSelectScenes().element.content[0];
      let domRect = dom.getBoundingClientRect();
      domToImage
        .toPng(dom, {
          style: {
            overflow: "hidden"
          },
          _width: domRect.width,
          _height: domRect.height,
          width: domRect.width,
          height: domRect.height,
          filter: node => node.tagName !== "VIDEO"
        })
        .then(dataUrl => {
          this.$bus.emit("eyedropperBox.addImage", { dataUrl, domRect });
        });
    },
    hideEyedropperBox() {
      this.$bus.emit("eyedropperBox.hide");
    },
    onColorNone(val) {
      this.$bus.emit(
        "colorPickerInput.draw",
        { hex: val },
        { type: this.boxData.data.whichPart }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../style/colors.scss";

.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 214px;
  height: auto;
  z-index: 35;
  box-shadow: 0 0 3px 1px #d8dee9;
  border-radius: 6px 6px 3px 3px;
  border: 1px solid #d8dee9;
  background-color: $c5;
  overflow: hidden;
  font-size: 14px;

  &__drag-area {
    line-height: 28px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
  }

  &__content {
    padding-top: 12px;
    padding-bottom: 30px;
  }

  &__recent-color {
    > div:first-child {
      text-align: left;
      padding-left: 20px;
      padding-right: 20px;
    }
    > ul {
      display: flex;
      justify-content: flex-start;
      width: 180px;
      margin-top: 8px;
      margin-left: auto;
      margin-right: auto;
      > li {
        width: 30px;
        height: 30px;
        cursor: pointer;
      }
    }
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }
}
.vc-sketch {
  box-shadow: none;
  margin-left: auto;
  margin-right: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/popups/colorPicker.vue